import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  IconButton,
  Collapse,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@material-ui/core";
import useStyles from "../../../themes/style.js";
import { IoChatboxOutline, IoChevronDownSharp } from "react-icons/io5";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../../../css/hierarcyTree.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { Alert, AlertTitle } from "@mui/material";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { IoIosCall, IoMdMail } from "react-icons/io";
// import 'react-tree-graph/dist/style.css'
import FamilyTree from "react-d3-tree";
import { getEmpName } from "../../../utils/constant";
import { jwtDecode } from "jwt-decode";

const randomProfileImage = () =>
  `https://randomuser.me/api/portraits/men/${Math.floor(
    Math.random() * 100,
  )}.jpg`;

const getLevelColor = (level) => {
  switch (level) {
    case "Special":
      return "#FF5733"; // Red
    case "Senior":
      return "#33A1FF"; // Blue
    case "Junior":
      return "#33FF57"; // Green
    default:
      return "#CCCCCC"; // Gray
  }
};

const EmployeeCard = ({ employee }) => {
  const [expanded, setExpanded] = useState(false);
  const levelColor = getLevelColor(employee.designation?.level?.level);

  return (
    <li>
      <div className="org-tree-card">
        <div className="image">
          <img
            src={randomProfileImage()}
            alt="Profile"
            style={{ borderColor: levelColor }}
          />
        </div>
        <div className="org-tree-card-body">
          <h4>{`${employee.employee.firstName} ${employee.employee.lastName}`}</h4>
          <p>
            {employee.designation
              ? employee.designation.title
              : "No Designation"}
          </p>
        </div>
        <div
          className="org-tree-card-footer"
          style={{ background: levelColor }}
        >
          <IoChatboxOutline />
          <IoIosCall />
          <IoMdMail />
        </div>
        {employee.children?.length > 0 && (
          <button className="expand-btn" onClick={() => setExpanded(!expanded)}>
            {expanded ? "▼ Hide Subordinates" : "▶ Show Subordinates"}
          </button>
        )}
      </div>

      {expanded && employee.children?.length > 0 && (
        <ul className="nested-list">
          {employee.children.map((child) => (
            <EmployeeCard key={child.id} employee={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

const HierarchyTree = () => {
  const orgChart = {
    name: "CEO",
    children: [
      {
        name: "Technical Support Specialist",
        attributes: {
          department: "Support",
          level: "Special",
        },
        children: [
          {
            name: "Muthu Kumaran",
            attributes: {
              role: "Employee",
            },
          },
        ],
      },
      {
        name: "Kannan G",
        attributes: {
          role: "Employee",
        },
        children: [],
      },
      {
        name: "Employee 1",
        attributes: {
          role: "Employee",
        },
        children: [],
      },
    ],
  };

  const classes = useStyles();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const calendarRef = useRef(null);
  const history = useHistory();
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    name: "CEO",
    children: [],
  });
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoader(true);
      console.log(decode);
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}hirerachy/hirerachy?userId=${decode.user_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.subordinates;

        const modifiedData =
          responseData.map((item) => ({
            name: item.fullName,
            attributes: {
              id: item?.id,
              designation: item?.designation?.title,
              department: item?.designation?.department.title,
              level: item?.designation?.level.level,
              children: [],
            },
          }));

        setEmployeeData({
          name: "Admin",
          children: modifiedData,
        });
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const getSubordinates = async (id) => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}hirerachy/hirerachy?userId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.subordinates;

        const modifiedData = responseData.map((item) => ({
          name: item.fullName,
          attributes: {
            id: item?.id,
            designation: item?.designation?.title,
            department: item?.designation?.department.title,
            level: item?.designation?.level.level,
          },
          children: [],
        }));
        console.log(modifiedData);

        // setEmployeeData({
        //   name: "Admin",
        //   children: modifiedData,
        // });
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  const handleNodeClick = (nodeDatum) => {
    if (nodeDatum.attributes?.id) {
      getSubordinates(nodeDatum.attributes.id);
    }
  };

  const renderNodeWithCustomEvents = ({
    nodeDatum,
    toggleNode,
    handleNodeClick,
  }) => (
    <>
      <rect
        x="-10"
        y="-20"
        width="240"
        height="100"
        fill="#E0FBE2"
        rx="10"
        ry="10"
      />
      <g>
        <circle
          fill="green"
          stroke="2"
          r="15"
          onClick={() => handleNodeClick(nodeDatum)}
        />
        <g>
          <text fill="red" strokeWidth="0" x="20" onClick={toggleNode}>
            {nodeDatum.name}
          </text>
          {nodeDatum.attributes?.department && (
            <g>
              <text fill="#717070" x="20" dy="20" strokeWidth="0">
                {nodeDatum.attributes?.department}
              </text>
              <text fill="#717070" x="20" dy="40" strokeWidth="0">
                {nodeDatum.attributes?.designation}
              </text>
              {/* <text fill="#717070" x="20" dy="60" strokeWidth="0">
              {nodeDatum.attributes?.level}
            </text> */}
            </g>
          )}
        </g>
      </g>
    </>
  );

  return (
    <div>
      <Grid container spacing={2}>
        <div className="w-100" style={{ height: "100vh" }}>
          <FamilyTree
            data={employeeData}
            orientation="vertical"
            pathFunc="elbow"
            rootNodeClassName="node__root"
            branchNodeClassName="node__branch"
            leafNodeClassName="node__leaf"
            nodeSize={{ x: 200, y: 150 }} // Increases spacing
            separation={{ siblings: 2, nonSiblings: 3 }} // Adjusts gaps
            translate={{ x: 300, y: 50 }} //
            renderCustomNodeElement={(rd3tProps) =>
              renderNodeWithCustomEvents({ ...rd3tProps, handleNodeClick })
            }
          />
        </div>
        {/* <Grid item xs={12}>
          <ul className="employee-list">
            {employeeData.map((emp) => (
              <EmployeeCard key={emp.id} employee={emp} />
            ))}
          </ul>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default HierarchyTree;
